var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15.8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7.9c0,.5-.3.9-.7,1L1.6,15.7c-.1,0-.3,0-.4,0-.3,0-.6-.1-.8-.4-.3-.3-.4-.9-.2-1.3l3.3-6.2L.1,1.7C0,1.2,0,.7.3.4c.2-.2.5-.4.8-.4s.3,0,.4.1l15.8,6.8c.4.2.7.6.7,1ZM15.5,8.5H4.3l-3.2,6.2,14.4-6.2ZM4.3,7.3h11.2L1.1,1.2s0,0,0,0l3.2,6.2Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refer.4b18e3a64e52db6615591c845067bdfd.svg";